import {CommonModule} from '@angular/common';
import {ChangeDetectorRef, Component, ElementRef, Inject, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {finalize} from 'rxjs/operators';

import {BasicPlanUpgradeSource} from '../models/basic-plan-limit.model';
import {Session} from '../services/Session';
import {BasicPlanLimitService} from '../tpiq-services/basic-plan-limit.service';

export interface BasicPlanUpgradeDialogData {
  source: BasicPlanUpgradeSource;
}

@Component({
  selector: 'app-basic-plan-upgrade-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './basic-plan-upgrade-dialog.component.html',
  styleUrl: './basic-plan-upgrade-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BasicPlanUpgradeDialogComponent {
  @ViewChild('successHeading') successHeading?: ElementRef<HTMLElement>;
  isSubmitting = false;
  requestSent = false;
  errorMessage = '';

  constructor(
    public readonly dialogRef: MatDialogRef<BasicPlanUpgradeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: BasicPlanUpgradeDialogData,
    private readonly basicPlanLimits: BasicPlanLimitService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  get title(): string {
    return this.data.source === 'JAINE' ? 'Upgrade to Access jAIne?' : 'Upgrade Your Subscription?';
  }

  get description(): string {
    return this.data.source === 'JAINE'
      ? 'jAIne is not available with the Basic subscription. Would you like Support to contact you about upgrading?'
      : 'Would you like Support to contact you about upgrading your Basic subscription?';
  }

  requestUpgrade(): void {
    if (this.isSubmitting) {
      return;
    }
    const orgId = Session.getOrg();
    const userId = Session.getUser()?.id;
    if (!orgId || !userId) {
      this.errorMessage = 'We could not identify your firm. Please sign in again and retry.';
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.basicPlanLimits.requestUpgrade(orgId, userId, this.data.source)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe({
        next: () => {
          this.requestSent = true;
          this.changeDetector.detectChanges();
          this.successHeading?.nativeElement.focus();
        },
        error: () => {
          this.errorMessage = 'We could not send your request. Please retry or email support@taxplaniq.com.';
        }
      });
  }
}
